import React from "react";
import { useNavigate } from "react-router-dom";

export default function About() {
  const navigate = useNavigate();
  const language = localStorage.getItem("language") || "en";

  const content = {
    en: {
      title: "About Umojai",
      backHome: "Back to Home",
      startChat: "Start Chatting",
      narrative: [
        "Umojai is a next-generation bilingual intelligence model engineered for English and Kiswahili, grounded in a hyper-heuristic framework developed by Prof. Stephen Akandwanaho. Unlike traditional AI models that depend on fixed learning pathways, Umojai dynamically orchestrates multiple problem-solving strategies to optimise responses in real time.",

        "The system combines web intelligence, semantic analysis, and reinforcement learning to produce context-aware, linguistically adaptive outputs. This enables deeper relevance, cultural sensitivity, and practical usability across African and global contexts.",

        "Umojai represents a shift toward adaptive, multilingual AI systems that are not only intelligent, but also inclusive, scalable, and aligned with emerging digital ecosystems."
      ],
    },

    sw: {
      title: "Kuhusu Umojai",
      backHome: "Rudi Mwanzo",
      startChat: "Anza Mazungumzo",
      narrative: [
        "Umojai ni mfumo wa kisasa wa akili bandia unaotumia lugha mbili—Kiingereza na Kiswahili—uliojenziwa juu ya mfumo wa hyper-heuristic uliobuniwa na Prof. Stephen Akandwanaho. Tofauti na mifumo ya kawaida ya AI inayotegemea mbinu zisizobadilika, Umojai hubadilisha na kuchagua mikakati mbalimbali ya utatuzi wa matatizo kwa wakati halisi ili kuboresha majibu yake.",

        "Mfumo huu unaunganisha taarifa kutoka kwenye tovuti, uchambuzi wa maana (semantic analysis), na mbinu za kujifunza kupitia mrejesho (reinforcement learning) ili kutoa majibu yenye muktadha sahihi na yanayozingatia lugha na utamaduni.",

        "Umojai unaashiria mabadiliko kuelekea mifumo ya AI inayoweza kubadilika, inayozingatia lugha nyingi, na inayolenga ujumuishaji, upanuzi, na maendeleo ya mifumo ya kidijitali barani Afrika na duniani."
      ],
    },
  };

  const { title, backHome, startChat, narrative } = content[language] || content.en;

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fb" }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "18px 32px",
          borderBottom: "1px solid #e9ecef",
          backgroundColor: "#ffffff",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="/umojai-logo.png"
            alt="Umojai Logo"
            style={{ width: "40px", height: "auto", maxHeight: "40px" }}
          />
          <h4
            className="fw-bold ms-2"
            style={{
              color: "#0d6efd",
              margin: "0 0 0 10px",
              fontSize: "1.3rem",
            }}
          >
            Umojai
          </h4>
        </div>

        <button
          className="btn btn-outline-primary"
          onClick={() => navigate("/login")}
          style={{ borderRadius: "10px", padding: "8px 16px" }}
        >
          {backHome}
        </button>
      </div>

      {/* Main Content */}
      <div
        style={{
          maxWidth: "820px",
          margin: "60px auto",
          padding: "0 24px",
        }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "18px",
            padding: "40px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
          }}
        >
          <h1
            className="fw-bold"
            style={{
              marginBottom: "28px",
              fontSize: "3rem",
              lineHeight: "1.1",
            }}
          >
            {title}
          </h1>

          {narrative.map((para, index) => (
            <p
              key={index}
              style={{
                lineHeight: "1.8",
                fontSize: "1.08rem",
                marginBottom: "18px",
                color: "#212529",
              }}
            >
              {para}
            </p>
          ))}

          <div style={{ marginTop: "30px" }}>
            <button
              className="btn btn-primary"
              onClick={() => navigate("/login")}
              style={{ borderRadius: "10px", padding: "10px 18px" }}
            >
              {startChat}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}